// src/data/quizData.js
export const quizData = [
  {
    id: 1,
    question: '我对科技、知识、心灵成长方面的新发展、新发现很感兴趣，也会不断地充实自己这方面的知识。',
  },
  {
    id: 2,
    question: '在我做任何决定前，即使是生活中的小事，总是喜欢征求朋友或家人的建议和看法。',
  },
  {
    id: 3,
    question: '我是个有条理的人，喜欢把该做的事逐项地规划出来，可是有时列出来的项目，多到不知该如何着手。',
  },
  {
    id: 4,
    question: '我对暴力、武器和功夫相当痴迷，喜欢那些充满暴力和打斗的电影、影集或是游戏。',
  },
  {
    id: 5,
    question: '我有很丰富的想象力，当别人描述一个物品或事件时，我可以在脑海中清楚地描绘出该项物品或事件的影像。',
  },
  {
    id: 6,
    question: '当我做决定时，必须要考虑周详，且分析它的来龙去脉后，才能做下明确的抉择，因此有人认为我优柔寡断。',
  },
  {
    id: 7,
    question: '我很了解自己的能力、天赋、想从事的工作，以及什么对我而言，才是人生最重要的。',
  },
  {
    id: 8,
    question: '我时常嫉妒别人的好运或财富，处在际遇比我好的人群中，让我有低人一等的不自在。',
  },
  {
    id: 9,
    question: '在社交场合中，因为我怕会有不得体的言语或行为出现，所以尽可能有所保留。',
  },
  {
    id: 10,
    question: '我通常必须确定对方是真正喜欢我后，才会与他做更深一层的交往。',
  },
  {
    id: 11,
    question: '在社交场合中，我是个非常有自信的人，能够轻松自然、反应得体的与人交谈，不会让人有矫揉造作、不安的感觉。',
  },
  {
    id: 12,
    question: '我喜欢独自爬山、逛街、看电影等，并不需要任何人，甚至是家人的陪伴。我喜爱个人自由、清静的空间。',
  },
  {
    id: 13,
    question: '我偶尔会捏造一个故事或是歪曲事实，然后看别人的反应。但这样做只是想开别人玩笑罢了，一点恶意也没有。',
  },
  {
    id: 14,
    question: '仔细想想，我觉得自己在生活中真正喜欢，或能安心享乐的事，实在不多。',
  },
  {
    id: 15,
    question: '我不是个一板一眼的人，我喜欢做些紧张、刺激的事，如：飙车、酒后开车等，但我很明白自己的所作所为。',
  },
  {
    id: 16,
    question: '我喜欢精打细算，虽然有人认为我吝啬，但我相信每个人应该都有储蓄的好习惯，以备不时之需。',
  },
  {
    id: 17,
    question: '我周遭亲近的人，常说我老是看到事情不好的一面，他们说我的心态太消极悲观了。',
  },
  {
    id: 18,
    question: '当我情绪不好时，我会有相当夸大的表达方式，例如，大哭一场，摔破物品以泄愤，或是有自我伤害的行为出现。',
  },
  {
    id: 19,
    question: '我的亲友说，我小时候是个专门惹是生非的小捣蛋。我曾逃学、打架、说谎等，都是些令人头痛的事情。',
  },
  {
    id: 20,
    question: '我从小到现在，一直是大家心目中的乖宝宝，从不做一些违反规定、父母师长不允许的事情。',
  },
  {
    id: 21,
    question: '我对灵异的事情很感兴趣，有敏锐的「第六感」，常常在事情还未发生前，就能感受到有某件事情将要发生。',
  },
  {
    id: 22,
    question: '在社交场合或是平日的活动中，我总喜欢成为众人注目的焦点，不太安于配角或跑龙套的这种角色。',
  },
  {
    id: 23,
    question: '我崇尚浪漫、狂野的爱情，常常疯狂的投入一段恋情中。但有时会因为对方的一些小缺点，而无法克制厌恶及愤怒的情绪。',
  },
  {
    id: 24,
    question: '有人说我没有什么情绪变化，表情冷漠，甚至有人说我是「扑克脸孔」。',
  },
  {
    id: 25,
    question: '我凡事不喜欢被束缚、被限制，做事一向随兴而为。拟定生涯规划、依循行事规章等，对我而言太难了。',
  },
  {
    id: 26,
    question: '我擅长人际社交，处在人群中，往往是被众星拱月、目光焦聚的那个人。',
  },
  {
    id: 27,
    question: '虽然大家都说「内在美」比「外在美」重要，可是我觉得一个人的外貌是不可忽略。因此每天会花费时间来装扮自己，确定自己看起来美丽动人或是英俊潇洒。',
  },
  {
    id: 28,
    question: '当与他人相处时，我发现有时候自己无法完全放松，享受欢乐的时光。除非，确定其他人的需求都已经被满足了。',
  },
  {
    id: 29,
    question: '我通常让我的家人或伴侣，来帮我做重要的决定。',
  },
  {
    id: 30,
    question: '当有人真正关心我，给予我许多的关怀和温馨时，我通常会觉得很不自在，且难以接受；但我喜爱为他人解决困难。',
  },
  {
    id: 31,
    question: '我是完美主义者，对自我往往要求严苛，所以我比一般人花更多时间在份内的工作上。',
  },
  {
    id: 32,
    question: '或许我有点自我膨胀，可是我自认自己是个蛮特殊的人物。',
  },
  {
    id: 33,
    question: '有人觉得我会与他人保持某些距离，而且在生活和衣着上，有自己特殊的风格，所以有些人认为我是个「奇怪的人」。',
  },
  {
    id: 34,
    question: '当事情不如我意时，我会忍不住暴跳如雷，不分场合、对象、后果，大发脾气，有时会将场面搞得很僵。',
  },
  {
    id: 35,
    question: '我不喜欢人声鼎沸、摩肩接踵的庙会、狂欢晚会、社交场合、人与人间的频繁相处，让我身心疲惫。',
  },
  {
    id: 36,
    question: '我的同事和上司，并不能真正了解、激赏和重用我的才华。',
  },
  {
    id: 37,
    question: '除了我亲近的家人外，我只有二、三知己。',
  },
  {
    id: 38,
    question: '在陌生人群中，我常常会不知所措，感到害羞或焦虑。',
  },
  {
    id: 39,
    question: '做事时，我常常会觉得后继无力，有时会半途而废，要不然就是用拖拖拉拉，差不多的办法来草草了事，敷衍交差。',
  },
  {
    id: 40,
    question: '我是个非常注重隐私的人，我不轻易跟人分享我个人的资料。因为你永远不知道别人会如何利用这些资料，来做为谋取利益或算计你的工具。',
  },
  {
    id: 41,
    question: '我喜欢在群众间放送魅力，并且希望别人觉得我很性感、很有吸引力。',
  },
  {
    id: 42,
    question: '当一段亲密的友谊或爱情结束时，我会觉得孤单无依、彷徨无助，常不自觉地急着寻求新的亲密关系。',
  },
  {
    id: 43,
    question: '我认为严格的管理非常重要，我深信员工需要有严谨训练，必需确切遵循公司规范。',
  },
  {
    id: 44,
    question: '当别人批评我或是称赞我时，我通常都不会有明显或强烈的情绪反应。',
  },
  {
    id: 45,
    question: '我的情绪常因外在的环境起伏变化很大，可是我无力也无法控管。',
  },
  {
    id: 46,
    question: '我喜欢呼朋引伴、聚餐、唱卡拉OK，我就是受不了独处，尤其热爱与一群同伴狂欢作乐，参加派对，享受刺激。',
  },
  {
    id: 47,
    question: '如果我有选择余地的话，我宁愿独自处理事情或独来独往。',
  },
  {
    id: 48,
    question: '我喜欢用一种生动、活泼、戏剧性的方式来表达我的感觉，或描述事件。',
  },
  {
    id: 49,
    question: '有人告诉我：我是一个很有个性的人。不管是谁把我惹毛，我都会禁不住想与对方理论或是争出输赢。',
  },
  {
    id: 50,
    question: '我对别人心中的企图有种特殊敏锐的觉察力，即使这个企图只在酝酿的初期阶段，我都能感受到。',
  },
  {
    id: 51,
    question: '当我处在很大压力下，可能变得有点偏执。有时会胡思乱想、疑神疑鬼，或以置之不理的方式来做逃避。',
  },
  {
    id: 52,
    question: '我崇尚可游走在法令边缘，但不会被惩罚的生活。',
  },
  {
    id: 53,
    question: '我的情绪平和，很少有大吼大叫，失去控制的状况发生。',
  },
  {
    id: 54,
    question: '我很依赖我生命中亲密的伙伴，常担心如果有一天失去他的话，可能没能力照顾自己。',
  },
  {
    id: 55,
    question: '我喜欢付出、满足别人的需求，有时觉得自己为他人付出太多了。',
  },
  {
    id: 56,
    question: '我是个成功，有声名、地位，或是有才干的人。所以，在某些场合，应该得到某方面特殊的礼遇。',
  },
  {
    id: 57,
    question: '有人说我有「收集癖」。对那些老旧、无用，没有任何实际价值或抽象意义的物品，总舍不得丢弃。',
  },
  {
    id: 58,
    question: '我不喜欢一成不变的工作，往往为了要从事自己喜欢的事，而无法将份内工作，做得很完善。有时会使出「拖」手段，或是把该做的事，暂时搁一边。',
  },
  {
    id: 59,
    question: '朋友常说我犹如古代的侠客，喜欢「路见不平，拔刀相助」，是现代的「正义之声」。',
  },
  {
    id: 60,
    question: '有人说我骄傲自大，可是我完全不在乎他人评论。',
  },
  {
    id: 61,
    question: '在大型的社交场合中，常令我感到焦虑不安，即使与熟识的人在一起，还是会觉得别人用评估的眼光打量着我。',
  },
  {
    id: 62,
    question: '我是个有名的胆小鬼，几乎什么新奇的玩意儿都不肯轻易尝试，我喜欢生活在熟悉的生活空间里。',
  },
  {
    id: 63,
    question: '朋友常说我是个理智型的人，每件事都会再三思考及分析后，才会去实行。有时甚至会有过度烦忧的倾向。',
  },
  {
    id: 64,
    question: '我不太在乎别人的看法，我的情绪表达随着当时内在的感触而定，所以有时会有不合时宜的事件发生。',
  },
  {
    id: 65,
    question: '我没有耐性长期从事一成不变的工作。对于生活必需的杂事，我并不在行。所以有些人认为我不负责任。',
  },
  {
    id: 66,
    question: '有人曾告诉过我，我情绪表达的方式十分夸张，令他们搞不清楚事情的真实性到底有多少。',
  },
  {
    id: 67,
    question: '我家中成员，或公司部属，抱怨我制定的规则过多，且太过严苛，没有给予他们足够独立自主的空间。',
  },
  {
    id: 68,
    question: '若有对我不忠诚、不尊重，或是有不公平的待遇，我可能怀恨在心，久久无法释怀。',
  },
  {
    id: 69,
    question: '在帮助别人、为别人付出的过程中，我找到了人生的意义和最大的快乐。',
  },
  {
    id: 70,
    question: '如果当我「该」做的事和我「想」做的事，发生冲突时，我会矛盾、挣扎，虽然免不了有愧疚之心，但十之八九会选择我「想」做的事。',
  },
  {
    id: 71,
    question: '我可能是个深具威严的人，因为有人曾告诉我，他们遵循我的指令，是因为他们怕我。',
  },
  {
    id: 72,
    question: '我非常地情绪化，一点小事就足以使我大发雷霆，且在短短的几个小时中，从快乐到忧伤，从焦虑到生气。可是往往负面情绪，都不会持续太久。',
  },
  {
    id: 73,
    question: '我不喜欢尝试冒险或新奇的事物，一则我怕面对不可知，再则我怕会丢人现眼。',
  },
  {
    id: 74,
    question: '我喜欢放纵自己，一切跟着感觉走，如果感觉对时，可能会买醉狂欢，也可能会飚车或是「大买特买」。',
  },
  {
    id: 75,
    question: '我不喜欢人与人之间勾心斗角、交际应酬等，这些错综复杂的人际关系。我最大的心愿就是能放下世俗的一切，隐居山林。',
  },
  {
    id: 76,
    question: '常有人说：我是个「工作狂」。即使目前已有足够家产，我仍然会认真工作。',
  },
  {
    id: 77,
    question: '我喜欢想象自己拥有财富、权势或名气，而备受赞赏，或是由于自己的才能或美貌受到大众的喜好及崇拜。',
  },
  {
    id: 78,
    question: '我会尽所能的为他人服务，有时免不了造成本身的一些不便，但还是会想尽办法让别人喜欢我。',
  },
  {
    id: 79,
    question: '我常常会误认别人有意要追求我，或是对我有好感，这种揣测，有时不免对我造成困扰或不可避免的尴尬场面。',
  },
  {
    id: 80,
    question: '面对爱情，我没有强烈的憧憬和欲望。',
  },
  {
    id: 81,
    question: '在生活中，我不会因为某方面的成功而欣喜异常，总会意识到在人生的某一方面，有困难发生。',
  },
  {
    id: 82,
    question: '在与人相处时，我喜欢表现出附和对方的态度，当不同意某个人的看法，只会把不满的情绪放在心里。',
  },
  {
    id: 83,
    question: '从小到现在，常有师长、长辈告诉我，如果我凡事多努力些，一定会有比现在更好的成就。',
  },
  {
    id: 84,
    question: '有时候我觉得周遭的人，包括：家人、朋友、同事，对我并不如期待中那么的忠诚。',
  },
  {
    id: 85,
    question: '我相信在某些状况下，必须牺牲他人利益，以达成自我目标。',
  },
  {
    id: 86,
    question: '我对上位者或是上司，常带着批判的态度，或许我并没有真正了解到他们立场，但我相信我能把事情处理得比他们好。',
  },
  {
    id: 87,
    question: '别人觉得我是一个非常幽默风趣的人，可以把日常平凡无奇的事，描述得生动有趣、引人入胜。',
  },
  {
    id: 88,
    question: '我发现自己会嘲讽别人的不幸，虽然我不以这种行径为荣，但只想表达这是个「弱肉强食」的社会状态罢了！',
  },
  {
    id: 89,
    question: '我对自己没有强烈的自信心，常对自我的能力感到怀疑，有时候甚至觉得自己一无是处。',
  },
  {
    id: 90,
    question: '我脑袋里，常充满纷纷扰扰的思绪，我喜欢花费大把时间、精力，去捕捉脑内思绪，努力探索解答。因此，常疏忽现实生活的柴米油盐。',
  },
  {
    id: 91,
    question: '我不是个积极主动的人，在团体中，宁愿做个追随者，成为一个安分守己且十分忠诚的成员。',
  },
  {
    id: 92,
    question: '我会毫不犹豫向人倾诉我的困扰，但当别人想给予我资助及关怀时，却往往无法坦然接受。',
  },
  {
    id: 93,
    question: '有人说我说话有时太过尖酸刻薄、不留情面，但如果他们认为我太过吹毛求疵的话，就应该勇敢为自己辩护。',
  },
  {
    id: 94,
    question: '我想我的接收力与大多数的人不同，有时可以感受到一些奇怪的事，虽然无法证实或解说这些现象，但对我而言，它们是那么的真确，例如：看到死去的亲人或感受到特殊的能量等等。',
  },
  {
    id: 95,
    question: '我希望自己不那么担忧，别人对我在社交场合的看法。',
  },
  {
    id: 96,
    question: '当别人要求我去做一件我不想做的事，我会以争辩、生气或是闹别扭的方式来做抗争，让他们不能「轻易得逞」。',
  },
  {
    id: 97,
    question: '在思想上，我是个自由激进的人，会向传统思维挑战，也不在乎别人对我有何看法。',
  },
  {
    id: 98,
    question: '有人说我太过固执己见，凡事都要依照自己特有的行事方法去做，且亲自监督。我宁愿别人骂我顽固，也不要他们乱搞一通或是半途而废。',
  },
  {
    id: 99,
    question: '我有时会为了捉弄他人、逃避责任，或是为自己牟利而不告诉别人事实的真相。',
  },
  {
    id: 100,
    question: '我是个缺乏安全感的人，在我的亲密关系中，我经常担心伴侣对我是否忠诚。',
  },
  {
    id: 101,
    question: '我喜欢保有个人隐私，因此对个人情感、嗜好、事件都多所保留，因此有人说我是个世故圆滑的人，常常猜不到我葫芦里卖的是什么药。',
  },
  {
    id: 102,
    question: '我对人心怀戒心，不轻易信赖他人，有时会试着去相信别人，但常不自禁地担心他人会占我便宜。',
  },
  {
    id: 103,
    question: '有人会认为我常无病呻吟，但他们不了解这些不幸的事情，确实发生在我身上。',
  },
  {
    id: 104,
    question: '有人说我自找苦吃，不断与一些令自己失望的人交往，让自己伤心痛苦。我实在无法理解为什么自己这么缺乏判断力。',
  },
  {
    id: 105,
    question: '我位居上流阶层，和我交往的人，或是我所加入的组织、俱乐部等，都具有相当的影响力和重要性。',
  },
  {
    id: 106,
    question: '我觉得我的内在世界空洞，不知自己的定位在哪里？也无法寻找到我人生的目标和意义。',
  },
  {
    id: 107,
    question: '我喜欢自己平常做事的方法，如果别人试着想改变我这些行事原则的话，我会择善固执，对别人的意见不加以理睬。',
  },
  {
    id: 108,
    question: '有人说，我是个拖拖拉拉或差不多先生(差不多小姐)。我的人生观是：人生苦短，要及时行乐，凡事做得过得去就可以，不需要事事追求完美。',
  },
  {
    id: 109,
    question: '有人说，我表达的方式很独特，他们认为我所说的事，对他们而言太过深奥，或者甚至不了解我谈话的内容。',
  },
  {
    id: 110,
    question: '我认为，我不需要对自己过去不良的行为感到内疚，或是有任何的罪恶感。',
  },
  {
    id: 111,
    question: '别人对我说，我对自我的要求太过严苛，常为一些小事自责过深。',
  },
  {
    id: 112,
    question: '有人说我很自我中心，虽然我自认了解别人的心情，但他们老是告诉我，我无法体会他们的感受。',
  },
  {
    id: 113,
    question: '对我而言，嫉妒是人生的一部分，不是我嫉妒着别人的财富、成就，就是有人可能嫉妒着我所拥有的一切。',
  },
  {
    id: 114,
    question: '我无法忍受严苛的社会现实面，因此我休闲时喜欢沉溺于追星、偶像剧、时尚等，浪漫氛围里。',
  },
  {
    id: 115,
    question: '我不是个非常主观的人，因此容易受他人影响，我必须时时提醒自己这一点，要不然常常会被他人的意见所左右。',
  },
  {
    id: 116,
    question: '在人群中，我觉得安全无忧。若要孤独地去面对人生，我会彷徨失措，完全不知该如何来照顾自己。',
  },
  {
    id: 117,
    question: '有人认为我太过保守和严苛，可是我深信没有任何理由和借口，可以原谅那些违反道德规范的行为。',
  },
  {
    id: 118,
    question: '我不是快乐无忧的人，有很多烦忧压在我心上，并且有比较严谨保守的倾向。',
  },
  {
    id: 119,
    question: '我有天马行空的想象力，在朋友圈中，我以点子多出名，有人说我是个「点子王」。',
  },
  {
    id: 120,
    question: '我喜欢接受赞美，当才华被肯定时，是我最高兴的一件事，一旦觉得自己被忽视时，我会想办法博取他人对我的赞赏。',
  },
  {
    id: 121,
    question: '我有时候担心自己关心的人，或是亲近朋友不喜欢我，会去试探，并要他们再三保证对我的忠诚和爱恋。我想这对他们而言，可能会造成某种程度的困扰。',
  },
  {
    id: 122,
    question: '在人数不多的工作场合，我觉得比较自在，因为受不了我的工作能力被其他同事质疑、批评。',
  },
  {
    id: 123,
    question: '朋友说，我是个善变的动物，他们形容我的情绪像不断翻页的书，喜怒无常，不是个容易相处的人。',
  },
  {
    id: 124,
    question: '在人际关系中，不管在公司或在家里，我总喜欢居于主控的地位，有时让他人觉得很粗鲁或是严苛，而不自觉。',
  },
  {
    id: 125,
    question: '朋友说，我是个有才干的人，会利用这些才能来帮助别人。但似乎没有利用到这些天赋，来使自己在事业上或是家庭中得到利益。',
  },
  {
    id: 126,
    question: '面对挑战，我会谨慎评估可能的风险、胜算，必须有十拿九稳的把握，才会放手去做。',
  },
  {
    id: 127,
    question: '我发现有一些人故意做一些烦扰、侮辱我的事，他们的目的只是想挑衅我。',
  },
  {
    id: 128,
    question: '有人说我天真无知得可爱，对人的包容性也出奇的大，有时会被利用，甚至有时被人利用而不自知。',
  },
  {
    id: 129,
    question: '我并不需要与很多人建立起亲近的人际关系，我会把大部分的精力，专注在思想哲理、抽象概念和超自然等内心世界的探讨上。',
  },
  {
    id: 130,
    question: '当遇到挫折时，我喜欢自己面对困难，当别人对我伸出援手时，往往会觉得不自在，无法坦然接受别人所释出的善意。',
  },
  {
    id: 131,
    question: '工作时，我通常会制定短期、中期规划，并会努力按照计划实行，也几乎都能坚持、贯彻原定计划。',
  },
  {
    id: 132,
    question: '我工作时，通常会将工作内容做出妥善分配，往往能在截止日期前完成工作，因此常有充分时间做检查和修正。',
  },
  {
    id: 133,
    question: '面对事务时，我偏爱收集所有可能信息，并喜欢遵循可信赖的标准和执行程序，以确保事情进行都在掌握中。',
  },
  {
    id: 134,
    question: '我工作时，通常能心无旁骛将事情处理完备，有时会废寝忘食，而危害身体健康。',
  },
  {
    id: 135,
    question: '我习惯“今日事、今日毕”，也常因我的坚持，可能会造成我周遭工作伙伴、朋友、家人的困扰。',
  },
  {
    id: 136,
    question: '做事时，我喜欢条理分明。因此，不管在家或是工作环境，总会将所有物品做好归类、收纳，让人觉得我很严谨。',
  },
  {
    id: 137,
    question: '我是一个注重承诺的人，一旦答应别人就会努力完成，虽然常给自己带来很大困扰、麻烦，但我还是坚持这个处事原则。',
  },
  {
    id: 138,
    question: '我工作时，常选择沉潜、低调，不会到处夸耀自己的成就。',
  },
  {
    id: 139,
    question: '我相信“君子爱财、取之有道”，绝不因想多赚钱，而做出危害他人权益的事。',
  },
  {
    id: 140,
    question: '面对人际间的相处，我常抱持着“宁人负我、我不负人”的心态。因此，有时会让自己遭受权益损失。',
  },
];
